export const serializeDate = (dateObj) => (dateObj ? dateObj.getTime() : null);

export const deserializeDate = (timestampStr) => (timestampStr ? new Date(timestampStr) : null);
